import dayjs from "dayjs"
import PortalRoleTypes from "../../../types/portalRoleTypes/PortalRoleTypes"

const PortalRoleBoilerplate: PortalRoleTypes = {
    PortalRoleId: 0,
    RoleName: null,
    Description: null,
    RoleCategory: null,
    MapToLPRoleCsv: null,
    IsProtected: false,
    CreatedDate: dayjs().format(),
    CreatedBy: null,
    ModifyDate: null,
    ModifiedBy: null,
    DeletedDate: null,
    DeletedBy: null,
    DisabledDate: null,
    DisabledBy: null
}

export default PortalRoleBoilerplate